<h1 class="mb-6">Gebühren</h1>

@if (settingsService.loading === LoadingState.Loading) {
  <p-progressBar mode="indeterminate" [style]="{'height': '6px'}"></p-progressBar>
}

@if (settingsService.loading === LoadingState.Data) {
  <form (ngSubmit)="save()" [formGroup]="globalSettingsForm">
    <h5>Alter, ab dem Leistungen zustehen</h5>
    <span class="field">
      <input type="number" class="w-100" pInputText formControlName="adultAge">
    </span>
    <h5 class="mt-4">Preis für eine Kiste</h5>
    <div class="mb-4 w-100">
      <p-iconfield>
        <p-inputicon class="pi pi-euro"></p-inputicon>
        <input id="single-box-price" class="w-100" type="number" pInputText formControlName="singleBoxPrice">
      </p-iconfield>
    </div>
    <h5 class="">Preis ab der zweiten Kiste</h5>
    <div class="w-100">
      <p-iconfield>
      <p-inputicon class="pi pi-euro"></p-inputicon>
      <input id="extra-box-price" class="w-100" type="number" pInputText formControlName="extraBoxPrice">
      </p-iconfield>
    </div>
    <h5 class="mt-4">Befristung aktiver Bezug (in Jahren)</h5>
    <div class="flex align-items-center">
      <p-toggleswitch class="mr-2" formControlName="expirationActivated"></p-toggleswitch>
      <span class="field flex-grow-1 mb-0">
        <input type="number" class="w-100" pInputText formControlName="expirationDuration">
      </span>
    </div>
    <h5 class="mt-4">Blockierung nach aktivem Bezug (in Jahren)</h5>
    <div class="flex align-items-center">
      <p-toggleswitch class="mr-2" formControlName="blockedActivated"></p-toggleswitch>
      <span class="field flex-grow-1 mb-0">
        <input type="number" class="w-100" pInputText formControlName="blockedDuration">
      </span>
    </div>
    <div class="w-100 d-flex justify-content-end mt-4">
      <p-button type="submit" label="SPEICHERN" icon="pi pi-save"
                [disabled]="!globalSettingsForm.valid || !globalSettingsForm.dirty"></p-button>
    </div>
  </form>
}

@if (settingsService.loading === LoadingState.Error) {
  <div class="w-100 d-flex justify-content-center text-muted">Ein Fehler ist aufgetreten</div>
}


